export default __webpack_public_path__ + "static/media/air.04208069.svg";